import React from 'react';
import cloneDeep from 'lodash.clonedeep';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { QUERY_LOC_FROM_AMF_ID } from 'xcipio/constants';
import { Warrant } from 'data/warrant/warrant.types';
import setAllTemplateFieldsAsReadOnly from 'utils/formTemplate/setAllTemplateFieldsAsReadOnly';
import DynamicForm, { ChangedField } from '../../../shared/form';

type WarrantDetailsProps = {
  shouldWarrantDetailUpdate: boolean
  defaults: Warrant
  formTemplate: FormTemplate
  originalValues?: Warrant
  fieldUpdateHandler: (changedField: ChangedField) => void
  mode: string
}

class WarrantDetails extends React.Component<WarrantDetailsProps> {
  formRef: DynamicForm | null = null

  modifyContact = (defaults: any): void => {
    if (defaults && defaults.contact) {
      defaults.contact = defaults.contact.id;
    }
  }

  // when view existing warrant, set attachments button clickable
  modifyTemplateInViewMode = (fields: any): void => {
    if (this.props.mode === 'view') {
      Object.keys(fields).forEach((key: any) => {
        if (key === 'attachments') {
          fields[key].className = 'formEnabled';
        }
      });
      setAllTemplateFieldsAsReadOnly(fields);
    }
  }

  isValid(): boolean {
    if (this.formRef) {
      return this.formRef.isValid(true, true);
    }
    return true;
  }

  shouldComponentUpdate(nextProps: WarrantDetailsProps): boolean {
    return nextProps.shouldWarrantDetailUpdate;
  }

  render(): JSX.Element {
    const defaults = cloneDeep(this.props.defaults);
    const { fields } = cloneDeep(this.props.formTemplate.general as FormTemplateSection);
    this.modifyTemplateInViewMode(fields);
    this.modifyContact(defaults);

    if (fields.targetOptionDetails) {
      fields.targetOptionDetails.hide = 'false';
      fields.targetOptionDetails.readOnly = defaults.caseType !== 'QUERY_LOC_FROM_AMF' || defaults.caseOptTemplateUsed !== QUERY_LOC_FROM_AMF_ID;
    }

    Object.keys(fields).forEach((key) => {
      if (fields[key].type === 'select') {
        fields[key].options = fields[key].options?.sort((optionA, optionB) => {
          if (optionA.label === 'Select') { return -1; }
          if (optionB.label === 'Select') { return 1; }
          if (optionA.label === 'Any') { return 1; }
          if (optionB.label === 'Any') { return -1; }

          const labelA: string = optionA.label;
          const labelB: string = optionB.label;
          let idx = 0;
          const lenA = labelA.length;
          const lenB = labelB.length;

          while (idx < lenA && idx < lenB) {
            const currCharA = labelA.charAt(idx);
            const currCharB = labelB.charAt(idx);
            if (currCharA === currCharB) { idx += 1; } else {
              if (Number.isNaN(Number(currCharA)) && !Number.isNaN(Number(currCharB))) { return -1; }
              if (Number.isNaN(Number(currCharB)) && !Number.isNaN(Number(currCharA))) { return 1; }
              return labelA.charCodeAt(idx) - labelB.charCodeAt(idx);
            }
          }

          return lenA - lenB;
        });
      }
    });

    return (
      <div>
        <DynamicForm
          ref={(ref) => { this.formRef = ref; }}
          name={this.props.formTemplate.key}
          fields={fields}
          layout={((this.props.formTemplate.general as FormTemplateSection).metadata).layout?.rows}
          defaults={defaults}
          originalValues={this.props.originalValues}
          fieldUpdateHandler={this.props.fieldUpdateHandler}
          i18nKeyPrefix="warrant.form"
        />
      </div>
    );
  }
}

export default WarrantDetails;
